import React from 'react';
import {
	InputWrapper,
	NiceFormGroup,
	QuestionWrapper,
	RangeInputWrapper,
	RangeWrapper,
} from './Components.styles';
import Slider from 'rc-slider';
import { ApInput, ApIcon, colors } from '@alixpartners/ui-components';
import { Tooltip } from 'react-tippy';
import { TooltipContent } from 'Waves/Waves.styles';

const SliderInput = ({
	questionNo,
	label,
	onChange,
	name,
	value,
	instructions,
	required,
}) => {
	const hasError =
		required && (value === '' || value === null || value === undefined);
	return (
		<NiceFormGroup>
			<div style={{ display: 'flex', alignItems: 'center' }}>
				<QuestionWrapper>
					<div className="questionNo">{questionNo}.&nbsp;</div>
					<label style={{ lineHeight: '1.3' }}>{label}</label>
					{instructions && (
						<Tooltip
							position="bottom"
							animation="fade"
							arrow
							html={<TooltipContent>{instructions}</TooltipContent>}
							trigger="mouseenter"
							style={{ marginBottom: '4px', marginLeft: '5px' }}
						>
							<ApIcon
								iconName="info"
								iconSize="22px"
								outlined={true}
								iconColor={colors.green300}
							/>
						</Tooltip>
					)}
				</QuestionWrapper>
			</div>
			<RangeInputWrapper>
				<InputWrapper>
					<ApInput
						symbol={'%'}
						value={value ?? 0}
						type="text"
						error={hasError}
						onChange={e => {
							let obj = {
								target: {
									value: e > 100 ? 100 : e,
									name: name,
									type: 'slider',
									isNumber: true,
								},
							};
							onChange(obj);
						}}
					/>
				</InputWrapper>
				<RangeWrapper>
					<Slider
						min={0}
						max={100}
						defaultValue={0}
						value={value}
						step={10}
						onChange={e => {
							let obj = {
								target: {
									value: e,
									name: name,
									type: 'slider',
								},
							};
							onChange(obj);
						}}
					/>
				</RangeWrapper>
			</RangeInputWrapper>
		</NiceFormGroup>
	);
};

export default SliderInput;
